import React, { useState } from "react";
import Modal from "../../../component/ui/modal";
import TextInput from "../../../component/element/forms/TextInput";
import {
  ICreateCompanyBranchUser,
  ICreateCompanyBranchUserError,
} from "../../../store/types/company";
import {
  create_company_branch_user,
  get_company_branches,
} from "../../../services/apis/companies";
import { useAppDispatch, useAppSelector } from "../../../store";
import SelectOption from "../../../component/element/forms/SelectOption";
import { ICreateCompanyEmployee } from "../../../store/types/companies";

type IAddUser = {
  show: boolean;
  isClose: () => void;
  companyId: number;
};

const AddUser = ({ show, isClose, companyId }: IAddUser) => {
  const dispatch = useAppDispatch();
  const [branchId, setBranchId] = React.useState("");
  const [branchError, setBranchError] = React.useState("");
  const branches = useAppSelector(({ companies }) =>
    companies.branchesCompanyId === companyId ? companies.branches : [],
  );
  const branchesLoading = useAppSelector(
    ({ companies }) =>
      companies.branchesCompanyId === companyId && companies.branchesLoading,
  );
  const loading = useAppSelector(
    ({ companies }) => companies.creatingEmployeeCompanyId === companyId,
  );
  const [user, setUser] = useState<ICreateCompanyBranchUser>({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  const [error, setError] = useState<ICreateCompanyBranchUserError>({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  const onValidate = () => {
    let valid = true;
    const newError: ICreateCompanyBranchUserError = {
      name: "",
      email: "",
      phone: "",
      address: "",
    };

    if (!user.name) {
      newError.name = "error: this field is required";
      valid = false;
    }
    if (!user.email) {
      newError.email = "error: this field is required";
      valid = false;
    }
    if (!user.phone) {
      newError.phone = "error: this field is required";
      valid = false;
    }
    if (!user.address) {
      newError.address = "error: this field is required";
      valid = false;
    }

    setError(newError);
    return valid;
  };

  const clear = () => {
    setBranchId("");
    setBranchError("");
    setError({
      name: "",
      email: "",
      phone: "",
      address: "",
    });
    setUser({
      name: "",
      email: "",
      phone: "",
      address: "",
    });
  };

  React.useEffect(() => {
    if (
      show &&
      Number.isInteger(companyId) &&
      companyId > 0 &&
      branches.length === 0 &&
      !branchesLoading
    ) {
      get_company_branches(dispatch, companyId);
    }
  }, [branches.length, branchesLoading, companyId, dispatch, show]);

  const handleOk = async () => {
    const isValid = onValidate();
    const selectedBranchId = Number(branchId);
    const isBranchValid =
      Number.isInteger(selectedBranchId) &&
      branches.some((branch) => branch.id === selectedBranchId);
    setBranchError(isBranchValid ? "" : "Select a branch.");
    if (!isValid || !isBranchValid) return;

    const payload: ICreateCompanyEmployee = {
      ...user,
      branch_id: selectedBranchId,
    };
    if (await create_company_branch_user(dispatch, payload, companyId)) {
      clear();
    }
  };

  return (
    <Modal
      title="Add Branch Employee"
      open={show}
      onClose={() => {
        clear();
        isClose();
      }}
      onOkClick={handleOk}
      isLoading={loading}
    >
      <div className="space-y-4">
        <SelectOption
          label="Branches"
          placeholder="Choose branch"
          items={branches.map((branch) => ({
            id: branch.id,
            name: branch.name,
          }))}
          loading={branchesLoading}
          onChange={(value) => {
            setBranchId(value);
            setBranchError("");
          }}
          value={branchId}
        />
        {branchError && (
          <p className="text-sm text-red-600">{branchError}</p>
        )}
        {branchesLoading && (
          <p className="text-sm text-gray-500">Loading branches...</p>
        )}

        <TextInput
          label="Name"
          name="name"
          value={user.name}
          type="text"
          status={error.name}
          placeholder="Name"
          onChange={(e) => {
            const { name, value } = e.target;
            setUser({ ...user, [name]: value });
            setError({ ...error, [name]: "" });
          }}
        />
        <TextInput
          label="Email"
          name="email"
          value={user.email}
          type="email"
          status={error.email}
          placeholder="Email"
          onChange={(e) => {
            const { name, value } = e.target;
            setUser({ ...user, [name]: value });
            setError({ ...error, [name]: "" });
          }}
        />
        <TextInput
          label="Phone"
          name="phone"
          value={user.phone}
          type="text"
          status={error.phone}
          placeholder="Phone"
          onChange={(e) => {
            const { name, value } = e.target;
            setUser({ ...user, [name]: value });
            setError({ ...error, [name]: "" });
          }}
        />
        <TextInput
          label="Address"
          name="address"
          value={user.address}
          type="text"
          status={error.address}
          placeholder="Address"
          onChange={(e) => {
            const { name, value } = e.target;
            setUser({ ...user, [name]: value });
            setError({ ...error, [name]: "" });
          }}
        />
      </div>
    </Modal>
  );
};

export default AddUser;
